<template>
  <div>
    <el-form :inline="true">
      <!-- 搜索区域 -->
      <el-form-item>
        <el-input
          v-model="queryinfo.query"
          :clearable="true"
          @clear="getlist"
          :placeholder="$t('qsr') + $t('yhm')"
          style="width:240px"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="getlist"
          ></el-button>
        </el-input>
      </el-form-item>
      <!-- 发送通知按钮 -->
      <el-form-item>
        <el-button type="primary" @click="showAddNoticeDialog">{{ $t('notice.sendNotice') }}</el-button>
      </el-form-item>
    </el-form>

    <!-- 通知列表 -->
    <el-table v-loading="loading" :data="noticelist" border style="width: 100%;">
      <el-table-column type="expand" label="详情">
        <template slot-scope="{ row }">
          <el-form label-position="left" :inline="true" class="noticeform">
            <el-form-item :label="$t('notice.content') + '：'">
              <span>{{ row.content }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column prop="id" label="#"></el-table-column>
      <el-table-column prop="uid" :label="$t('yhm')">
        <template slot-scope="{ row }">
          {{ row.user_id == 0 ? $t('notice.allUsers') : row.uid }}
        </template>
      </el-table-column>
      <el-table-column prop="username" :label="$t('notice.username')">
        <template slot-scope="{ row }">
          {{ row.user_id == 0 ? $t('notice.allUsers') : row.username }}
        </template>
      </el-table-column>
      <el-table-column prop="title" :label="$t('notice.title')"></el-table-column>
      <el-table-column prop="is_read" :label="$t('notice.isRead')">
        <template slot-scope="{ row }">
          <el-tag :type="row.is_read == 1 ? 'success' : 'info'">
            {{ row.is_read == 1 ? $t('notice.read') : $t('notice.unread') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="create_at"
        :label="$t('notice.createTime')"
        :formatter="dateFormat"
      ></el-table-column>
      <el-table-column
        prop="update_at"
        :label="$t('notice.updateTime')"
        :formatter="dateFormat"
      ></el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <el-pagination
      :hide-on-single-page="total <= 10"
      background
      layout="prev, pager, next, total"
      :page-size="10"
      :total="total"
      :current-page="queryinfo.page"
      @current-change="changepage"
    ></el-pagination>

    <!-- 发送通知对话框 -->
    <el-dialog
      :title="$t('notice.sendNotice')"
      :visible.sync="addNoticeDialogVisible"
      width="50%"
      @close="addNoticeDialogClosed"
    >
      <el-form
        :model="addNoticeForm"
        :rules="addNoticeFormRules"
        ref="addNoticeFormRef"
        label-width="100px"
      >
        <el-form-item :label="$t('notice.receiver')" prop="user_id">
          <el-radio-group v-model="noticeReceiverType">
            <el-radio :label="0">{{ $t('notice.allUsers') }}</el-radio>
            <el-radio :label="1">{{ $t('notice.specificUser') }}</el-radio>
          </el-radio-group>
          <el-input
            v-if="noticeReceiverType === 1"
            v-model="addNoticeForm.user_id"
            :placeholder="$t('qsr') + $t('yhm')"
            style="margin-top: 10px;"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('notice.title')" prop="title">
          <el-input v-model="addNoticeForm.title"></el-input>
        </el-form-item>
        <el-form-item :label="$t('notice.content')" prop="content">
          <el-input
            type="textarea"
            v-model="addNoticeForm.content"
            :rows="5"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addNoticeDialogVisible = false">{{ $t('quxiao') }}</el-button>
        <el-button type="primary" @click="sendNotice">{{ $t('tijiao') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryinfo: {
        query: '',
        user_id: '',
        page: 1
      },
      noticelist: [],
      total: 0,
      loading: true,
      addNoticeDialogVisible: false,
      addNoticeForm: {
        user_id: '',
        title: '',
        content: ''
      },
      addNoticeFormRules: {
        title: [
          { required: true, message: this.$t('notice.titleRequired'), trigger: 'blur' },
          { min: 2, max: 50, message: this.$t('notice.titleLength'), trigger: 'blur' }
        ],
        content: [
          { required: true, message: this.$t('notice.contentRequired'), trigger: 'blur' },
          { min: 5, max: 1000, message: this.$t('notice.contentLength'), trigger: 'blur' }
        ]
      },
      noticeReceiverType: 0
    }
  },
  created() {
    this.getlist()
  },
  methods: {
    async getlist() {
      this.loading = true
      const { data } = await this.$http.get('/admin/user/noticeList', {
        params: this.queryinfo
      })
      if (data) {
        if (data.code !== 200) {
          this.$message.error(this.getlang(data.msg))
        } else {
          this.noticelist = data.data.list
          this.total = parseInt(data.data.count)
        }
      }
      this.loading = false
    },
    changepage(val) {
      this.queryinfo.page = val
      this.getlist()
    },
    dateFormat(row, column) {
      const time = column.property === 'create_at' ? row.create_at : row.update_at
      if (!time) return '--'
      const dt = new Date(parseInt(time) * 1000)
      const y = dt.getFullYear()
      const m = (dt.getMonth() + 1 + '').padStart(2, '0')
      const d = (dt.getDate() + '').padStart(2, '0')
      const hh = (dt.getHours() + '').padStart(2, '0')
      const mm = (dt.getMinutes() + '').padStart(2, '0')
      const ss = (dt.getSeconds() + '').padStart(2, '0')
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
    },
    showAddNoticeDialog() {
      this.addNoticeDialogVisible = true
    },
    addNoticeDialogClosed() {
      this.$refs.addNoticeFormRef.resetFields()
      this.addNoticeForm.user_id = ''
      this.addNoticeForm.title = ''
      this.addNoticeForm.content = ''
      this.noticeReceiverType = 0
    },
    sendNotice() {
      this.$refs.addNoticeFormRef.validate(async valid => {
        if (!valid) return
        const noticeData = {
          title: this.addNoticeForm.title,
          content: this.addNoticeForm.content,
          user_id: this.noticeReceiverType === 0 ? '' : this.addNoticeForm.user_id
        }
        if (this.noticeReceiverType === 1 && !noticeData.user_id) {
          return this.$message.error(this.$t('notice.userIdRequired'))
        }
        const { data } = await this.$http.post('/admin/user/sendNotice', noticeData)
        if (data.code !== 200) {
          return this.$message.error(this.getlang(data.msg))
        }
        this.$message.success(this.$t('notice.sendSuccess'))
        this.addNoticeDialogVisible = false
        this.getlist()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.el-pagination {
  margin-top: 15px;
  text-align: center;
}
.noticeform .el-form-item {
  width: 100%;
  margin-bottom: 0;
}
.noticeform .el-form-item__label {
  font-weight: 600 !important;
  color: #99a9bf !important;
}
</style>
